import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { Dates } from '../../packages/dates';
import Scrollable from '../../components/Scrollable';
import Ribbon from '../Ribbon/index';
import MyRecordings, { EmptyContent } from "./MyRecordings";
import ChannelSingleton from "../Epg/ChannelsSingleton";
import NpvrUploader from '../../AAF/Npvr/NpvrUploader';
import EpgPersistence from '../../AAF/Nepg/EpgPersistence';

class MyContentSeries extends Component {
  constructor(){
    super();
    this.state = {
      ribbons: [],
      isLoading: true,
    }

    this.limitItemsByRibbon = 4;
  }

  componentDidMount(){
    this.getSeries();
  }

  parseArrayToArrayOfArrayByLimit(series = [], limit){
    const ribbons = [];
    let ribbon = [];
    let aux = 0;
    for(let i=0; i<series.length; i++){
      if(aux< limit){
        ribbon.push(series[i]);
      }
      if(aux + 1 === limit){
        aux = 0;
        ribbons.push([...ribbon ]);
        ribbon = [];
      }
      else
        aux++;
      if(i + 1 === series.length ){
        ribbons.push([...ribbon ]);
      }
    }
    return ribbons;
  }

  shouldComponentUpdate(nextProps, nextState) {
    return JSON.stringify(this.state) !== JSON.stringify(nextState);
  }

  componentDidUpdate() {
    window.SpatialNavigation.makeFocusable();
    window.SpatialNavigation.focus();
  }

  componentWillReceiveProps(newProps){
    this.getSeries();
  }

  async getSeries() {
    this.setState({isLoading:true});
    let series = [];
    const { timeUsed, actions : { episodes = null } = {} } = this.props;
    if(episodes){
      const result = await NpvrUploader.listByCompleteUrl(episodes);
      if(Array.isArray(result.recordings) && result.recordings.length>0){
        series = result.recordings.map(record => {
          const {
            channel: { image, group_id: groupId, event: { ext_eventimage_name = null, name: title,group_id, description, date_begin } }, 
            pack_id: packId,
            actions,
            status,
            date,
            record_id
          } = record;
          const limit = ChannelSingleton.getNpvrStorage(groupId); // minutes
          const used = typeof timeUsed[packId] === 'number' ? timeUsed[packId] : 0; // minutes
          const dateOfRecord = EpgPersistence.needsOffset()
            ? new Dates(date, 'YYYY-MM-DDThh:mm:ssZ')
              .utcOffset(EpgPersistence.needsOffset(), false)
              .format("dddd DD/MM/YYYY 'a las' HH:mm'hs.'")
            : new Dates(date, 'YYYY-MM-DDThh:mm:ssZ').format(
              "dddd DD/MM/YYYY 'a las' HH:mm'hs.'"
            ); //Se sustituye por dateOfEvent
          const dateOfEvent = EpgPersistence.needsOffset()
            ? new Dates()
              .unix(date_begin)
              .utcOffset(EpgPersistence.needsOffset(), false)
              .format("dddd DD/MM/YYYY 'a las' HH:mm'hs.'")
            : new Dates().unix(date_begin).format("dddd DD/MM/YYYY 'a las' HH:mm'hs.'");
          return {
            isEpisode:true,
            group_id: group_id,
            cover: ext_eventimage_name || image.replace('https://', 'http://'),
            title,
            description: description,
            node: 'myRecords',
            record_id: record_id,
            status,
            actions: actions,
            used,
            limit,
            isRecord: true,
            dateOfRecord,
            dateOfEvent,
            date_begin:  record.channel && record.channel.event ? record.channel.event.date_begin : null,
            date_end:  record.channel && record.channel.event ? record.channel.event.date_end : null,
            duration:  record.channel && record.channel.event ? record.channel.event.duration : null,

            clickHandler: (e) => {
              this.props.handleRecordingPlay(group_id, title, actions, ( record.channel.event ? record.channel.event : null ));
            }
          };
        }); 
      }
    }
    const ribbons = this.parseArrayToArrayOfArrayByLimit(series, this.limitItemsByRibbon);
    this.setState({
      ribbons,
      isLoading: false
    })
  }

  render() {
    const { ribbons, isLoading } = this.state;
    return (
      <Scrollable height={'410px'}>
        <MyRecordings
        showTimeUsedBar={false}
        render={callback => (
          <div>
            {
              isLoading ? null : 
              ribbons.length>0 ? 
              ribbons.map(ribbon => {
                return(
                  <Ribbon
                    keyDownHandler={this.props.handleKeyPress}
                    showFooter={true}
                    id={'recordings'}
                    // title={this.props.title}
                    items={ribbon}
                    focusHandler={cardData => {
                      cardData.showActionBtns=false;
                      cardData.playButton=false;
                      cardData.langButton=false;
                      cardData.favouriteButton=false;
                      cardData.purchaseButtonInfo=null;
                      cardData.showBack=true;
                      this.props.setResumeData(cardData);
                      callback(cardData);
                    }}
                    setMetricsEvent={this.props.setMetricsEvent}
                    user={this.props.user}
                  />
                );
              }) 
              :
              <EmptyContent message={'No hay grabaciones'} />
            }
          </div>
        )}
      />
      </Scrollable>
    )
  }
}

MyContentSeries.propTypes = {
  title: PropTypes.string.isRequired,
  series: PropTypes.arrayOf(PropTypes.object).isRequired,
  timeUsed: PropTypes.object.isRequired,
  setResumeData: PropTypes.func.isRequired,
  setMetricsEvent: PropTypes.func.isRequired,
  handleRecordingPlay: PropTypes.func.isRequired,
};

MyContentSeries.defaultProps = {
  title: 'Series',
  series: [],
  timeUsed: { 0: 0 },
  setResumeData: () => null,
  setMetricsEvent: () => null,
  handleRecordingPlay: () => null,
};

export default MyContentSeries



// WEBPACK FOOTER //
// ./src/components/MyContent/Series.jsx